import config from "../../../config";

// Components & Molecules
import PageHero from "../PageHero";
import PageSection from "../PageSection";
import FoodHow from "./FoodHow";
import PageForm from "../PageForm";
import Button from "../../../components/Desktop/Button";

// Icons & Images
import hero_bka_a from "../../../assets/img/FoodEntrepreneurs/Desktop/hero_bkg_a.png";
import hero_bka_b from "../../../assets/img/FoodEntrepreneurs/Desktop/hero_bkg_b.png";
import sect1_img from "../../../assets/img/FoodEntrepreneurs/Desktop/sect1_img.png";
import sect2_img from "../../../assets/img/FoodEntrepreneurs/Desktop/sect2_img.png";
import sect3_img from "../../../assets/img/FoodEntrepreneurs/Desktop/sect3_img.png";
import sect4_img from "../../../assets/img/FoodEntrepreneurs/Desktop/sect4_img.png";
import sect5_img from "../../../assets/img/FoodEntrepreneurs/Desktop/sect5_img.png";
import sect6_img from "../../../assets/img/FoodEntrepreneurs/Desktop/sect6_img.png";
import sect7_img from "../../../assets/img/FoodEntrepreneurs/Desktop/sect7_img.png";

import { ReactComponent as TailedArrowRightIcon } from "../../../icons/TailedArrowRightIcon.svg";

var webUrl = config?.webUrl;

const FoodSections = () => {
  return (
    <>
      {/* Hero Section */}
      <PageHero
        bkg_a={hero_bka_a}
        bkg_b={hero_bka_b}
        sub_head={"Food Entrepreneurs"}
        main_head={
          <>
            <span className="text-primaryDark-400"> Expand Beyond </span> Your
            Home Kitchen
          </>
        }
        description={
          <>
            Access culinary resources and grow your fledging food business
            beyond your home with HomeCook’s reliable platform that provides
            resources & connections for food entrepreneurs.
          </>
        }
        children={
          <>
            <a href={webUrl} target="_blank" rel="noreferrer">
              <Button
                label={
                  <>
                    View Resource Pantry{" "}
                    <TailedArrowRightIcon className="w-[20px] h-[20px]" />
                  </>
                }
                variant="secondary"
              />
            </a>
          </>
        }
      />

      {/* Section One */}
      <PageSection
        heading={
          <>
            <span className="text-primaryDark-400"> Access kitchens </span> That
            Match <br />
            Your Goals
          </>
        }
        description={
          <>
            We’ll connect you with vetted kitchen spaces aligned to your
            cuisine, capacity, budget and location needs - so you can focus on
            growth.
          </>
        }
        pageSectionVariant="primary"
        button={{
          label: "View Kitchens",
          variant: "secondary",
          onClick: () => {
            window.open(webUrl + "/kitchen", "_blank");
          },
        }}
        image={sect1_img}
      />

      {/* Section Two */}
      <PageSection
        heading={
          <>
            <span className="text-primaryDark-400"> Get Guidance On </span>{" "}
            Compliance <br />
            Documentation
          </>
        }
        description={
          <>
            Access the permits, licenses, guidelines, and compliance resources
            you need to operate confidently and legally - without the confusion
            or guesswork.
          </>
        }
        pageSectionVariant="secondary"
        button={{
          label: "View Documentations",
          variant: "secondary",
          onClick: () => {
            window.open(webUrl + "/documentation", "_blank");
          },
        }}
        image={sect2_img}
      />

      {/* Section Three */}
      <PageSection
        heading={
          <>
            <span className="text-primaryDark-400">
              {" "}
              Grow Your Business Through{" "}
            </span>{" "}
            <br />
            Practical Culinary Training
          </>
        }
        description={
          <>
            Access hands-on programs and expert-led sessions designed to refine
            your production processes, improve quality and consistency, and help
            you scale your food business with confidence.
          </>
        }
        pageSectionVariant="primary"
        button={{
          label: "View Culinary Trainings",
          variant: "secondary",
          onClick: () => {
            window.open(webUrl + "/training", "_blank");
          },
        }}
        image={sect3_img}
      />

      {/* Section Four */}
      <PageSection
        heading={
          <>
            <span className="text-primaryDark-400"> Unlock Funding to </span>{" "}
            Fuel Your <br />
            Growth
          </>
        }
        description={
          <>
            Discover funding opportunities, grants, and financial support
            tailored for food entrepreneurs - helping you invest in equipment,
            production, and expansion without slowing your momentum.
          </>
        }
        pageSectionVariant="secondary"
        button={{
          label: "View Funding Opportunities",
          variant: "secondary",
          onClick: () => {
            window.open(webUrl + "/funding", "_blank");
          },
        }}
        image={sect4_img}
      />

      {/* Section Five */}
      <PageSection
        heading={
          <>
            <span className="text-primaryDark-400">
              {" "}
              Learn From Industry Experts{" "}
            </span>{" "}
            <br />
            Who’ve Done It Before
          </>
        }
        description={
          <>
            Get guidance from experienced chefs, operators, and food business
            professionals who can help you avoid costly mistakes, make smarter
            decisions, and grow your brand faster.
          </>
        }
        pageSectionVariant="primary"
        button={{
          label: "View Industry Experts",
          variant: "secondary",
          onClick: () => {
            window.open(webUrl + "/expert", "_blank");
          },
        }}
        image={sect5_img}
      />

      {/* Section Six */}
      <PageSection
        heading={
          <>
            <span className="text-primaryDark-400">
              {" "}
              Source Local, Fresh <br /> Ingredients{" "}
            </span>{" "}
            With Ease
          </>
        }
        description={
          <>
            Connect with trusted local suppliers for high-quality, fresh
            ingredients - helping you maintain great taste, control costs, and
            deliver consistent value to your customers.
          </>
        }
        pageSectionVariant="secondary"
        button={{
          label: "View Local Fresh Foods",
          variant: "secondary",
          onClick: () => {
            window.open(webUrl + "/farm", "_blank");
          },
        }}
        image={sect6_img}
      />

      {/* Section Seven */}
      <PageSection
        heading={
          <>
            <span className="text-primaryDark-400"> Be part of a </span>{" "}
            Community That <br />
            Moves You Forward
          </>
        }
        description={
          <>
            Join a network of fellow food entrepreneurs to share opportunities,
            discover resources, learn from real experiences, and grow together -
            not alone.
          </>
        }
        pageSectionVariant="primary"
        button={{
          label: "View Communities",
          variant: "secondary",
          onClick: () => {
            window.open(webUrl + "/communities", "_blank");
          },
        }}
        image={sect7_img}
      />

      {/* How It Works Section */}
      <FoodHow />

      {/* Homecook Form */}
      <PageForm buttonLabel="Join" />
    </>
  );
};

export default FoodSections;
